import { Component, Input, OnChanges } from "@angular/core";
import { DateService } from "@app/services/date.service";
import { catchError, tap } from "rxjs/operators";
import { ISimStatusInfo } from "../../_services/peripheral.service.ajs";
import { SimService } from "../../_services/sim.service";
import "./simStatusInfo.component.scss";

@Component({
    selector: "sim-status-info",
    template: require("./simStatusInfo.component.html")
})
export class SimStatusInfoComponent implements OnChanges {

    @Input() serial: string;

    // ---

    simStatus: ISimStatusInfo;
    statusMessage: string = "Updating SIM info...";
    inSession: boolean;
    inFailureState = false;
    isUnsupportedSim = true;
    tooltipString: string = "Updating...";

    constructor(
        private readonly dateService: DateService,
        private readonly simService: SimService
    ) {
    }

    ngOnChanges() {
        if (!this.serial) {
            return;
        }

        this.simService
            .getSimInfo(this.serial)
            .pipe(
                catchError((error, data) => {
                    this.handleError();
                    throw error;
                }),
                tap(simStatus => {
                    if (!simStatus?.SessionDetails) {
                        this.handleError();
                        return;
                    }

                    this.isUnsupportedSim = false;
                    this.simStatus = simStatus;
                    this.inSession = simStatus.SessionDetails?.dateSessionStarted && !simStatus.SessionDetails?.dateSessionEnded;

                    this.createStatusMessage();
                })
            ).subscribe();
    }

    // ---

    private createStatusMessage() {
        this.statusMessage = "SIM: ";
        this.tooltipString = `${this.simStatus.Usage.status}`;

        if (this.inSession) {
            this.statusMessage += "Online";
            this.tooltipString += ` - Session started ${this.dateService.relativeTime(this.simStatus.SessionDetails.dateSessionStarted)}`;
        }
        else {
            if (this.simStatus.SessionDetails.dateSessionEnded) {
                this.tooltipString += ` - Session ended ${this.dateService.relativeTime(this.simStatus.SessionDetails.dateSessionEnded)}`;
            }
            else {
                this.tooltipString += `No session recorded`;
            }

            this.statusMessage += `${this.simStatus.Usage.status}`;
        }

        this.tooltipString += ` - Usage: ${this.simStatus.Usage.dataUsageFormatted}`;

        if (this.simStatus.Usage.overageLimitReached) {
            this.tooltipString += "Overage Limit Reached";
            this.inFailureState = true;
        }

        switch (this.simStatus.Usage.status) {
            case "RETIRED":
            case "PURGED":
            case "DEACTIVATED":
                this.inFailureState = true;
        }
    }

    private handleError(): void {
        this.isUnsupportedSim = true;
        this.statusMessage = "";
    }
}


/*
ACTIVATED
ACTIVATION_READY
DEACTIVATED
INVENTORY
PURGED
REPLACED
RETIRED
TEST_READY
*/
